// extracted by mini-css-extract-plugin
module.exports = {"container":"LocationHours_container__1q9mz","title":"LocationHours_title__1UNPU","day":"LocationHours_day__eLk1S"};